var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"ripple":false,"flat":""},nativeOn:{"click":function($event){return _vm.onLangPress($event)}}},[_vm._v(_vm._s(_vm.lang))])}
var staticRenderFns = []

export { render, staticRenderFns }